export function upgradeItem(item) {
  return {
    type: 'UPGRADE_ITEM',
    payload: item,
  };
}
